import "../../../styles/uniqueNews.css";
import styles from "../../../styles/module/news.module.css";
import React from "react";
import api from "../../../services/api";
import CarouselIMG from "../img/CarouselIMG";
import Loading from "../others/Loading";
import { imagemURL, link_mapa } from "../../../services/variables";
export default class showNewsSytem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newsLast: [],
      dataFormat: "",
      renderLoading: true,
      multiImg: [],
    };
  }

  componentDidMount() {
    api
      .post(`/news/unique/${this.props.slugNewsSystem}`)
      .then((res) => {
        const result = res.data;
        if (result.err) {
          //this.setState({renderLoading: false});
          //this.setState({renderLoading: false});
        } else {
          console.log(result);
          this.setState({ newsLast: result.res, renderLoading: false });
        }
      })
      .catch((err) => console.log("erro, DB"));
  }

  render() {
    return (
      <div className={styles.container}>
        {this.state.renderLoading ? (
          <Loading />
        ) : (
          <>
            {this.state.newsLast.map((news, i) => (
              <div className={styles.newsItem} key={i}>
                <div className={styles.header}>
                  <img alt="notícias" src="/icons/seta-direita.svg" />
                  <h2 className={styles.title}>{news.TITULO}</h2>
                </div>
                <div>
                  <hr className="hr-news-unique"></hr>
                  {news.IMG != "logo.png" ? (
                    <></>
                  ) : (
                    <>
                      <br />
                      <br />
                      <br />
                    </>
                  )}
                </div>
                {this.props.slugNewsSystem === "municipio-mapa" && (
                  <div className="container-mapa">
                    <iframe
                      src={link_mapa}
                      allowfullscreen=""
                      loading="lazy"
                      className="mapa-localizacao"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                )}
                <div className="section-unique-news">
                  <div className="cards-unique-news" key={i}>
                    {news.IMG == "logo.png" ? (
                      <></>
                    ) : (
                      <div>
                        <img
                          alt="imagem da notícia"
                          src={
                            news.IMG == "logo.png"
                              ? "/imagens/logo.png"
                              : imagemURL + news.IMG
                          }
                          className="card-unique-img"
                        />
                      </div>
                    )}
                    <div className="card-unique-txt">
                      <div className="title-unique-body"></div>
                      <div
                        className={styles.content}
                        dangerouslySetInnerHTML={{ __html: news.CORPO_TEXTO }}
                      ></div>
                    </div>
                  </div>
                  {news.VIDEO && (
                    <div className={styles.videoWrapper}>
                      <iframe
                        width="560"
                        height="315"
                        className={styles.video}
                        src={news.VIDEO}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    </div>
                  )}
                  <CarouselIMG img={news.MULTIPLE_IMG} />
                </div>
                {news.IMG != "logo.png" ? (
                  <></>
                ) : (
                  <>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  </>
                )}
              </div>
            ))}
          </>
        )}
      </div>
    );
  }
}
